import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#fff ",
      //dark: "#00d8e7 ",
    },
    secondary: {
      main: "#077f83 ",
      light: "#00d8e7 ",
      dark: "#009999 ",
    },
    titulos: {
      main: "#DCFFCC   ",
      light: "#E9DB5D",
      dark: "#A29415",
      contrastText: "#242105",
    },
    whatsapp: {
      main: "#25d366 ",
      light: "#E9DB5D",
      dark: "#128c7e",
      contrastText: "#242105",
    },
  },
});

export default theme;
